import React from "react";

import { ModalConfirmation } from "@performyard/py-components";

import { DeleteDocumentModalProps } from "../../schema";

const DeleteDocumentModal = ({ show, onClose, onDelete }: DeleteDocumentModalProps) => {
	return (
		<ModalConfirmation
			isOpen={show}
			onClose={onClose}
			title="Delete Document?"
			message="Are you sure you want to delete this document? This action is permanent and cannot be undone."
			dangerouslySetClassName="!w-[416px] !min-w-[320px] [&_p]:!text-sm [&_p]:!mt-1"
			negativeButtonProps={{
				children: "Cancel",
				onClick: onClose,
			}}
			positiveButtonProps={{
				children: "Yes, Delete",
				onClick: onDelete,
				color: "red",
			}}
		/>
	);
};

export default DeleteDocumentModal;
